import { PropTypes } from 'prop-types'

const Label = ({ text, htmlFor }) => {
  return (
    <label htmlFor={htmlFor} className="block text-sm mb-1">
      {text}
    </label>
  )
}

Label.propTypes = {
  text: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
}

export default Label
